<template>
  <div>
    <div class="byte-dance-games-list">
      <sp-tabs v-model="active_index" :tabs="tabs">
        <template #default="{ tabs }">
          <byte-dance-games-list :key="active_index" v-bind="tabs[active_index].componentProps" />
        </template>
      </sp-tabs>
    </div>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'sp-tabs': () => import('@/components/sp-tabs'),
    'byte-dance-games-list': () => import('./components/byte-dance-games-list/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
    // 初始化数据
    initOps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active_index: 0,
      assign_selection: [],
    };
  },
  computed: {
    tabs() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { delivery_form } = campaign_config.config;
      const { fusion__channel_code } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      return fusion__channel_codes.value.map(advertiser => {
        return {
          label: advertiser.label,
          componentProps: {
            formItem: this.formItem,
            initOps: this.initOps,
            advertiserId: advertiser.advertiser_id,
            channelAlias: advertiser.list,
            tableData: [],
          },
        };
      });
    },
  },
  methods: {
    /**
     * 获取分配结果
     * @returns {Promise<Object[]>}
     */
    getAssignResult() {
      const is_valid = this.tabs.every(({ componentProps }) => componentProps.tableData.length);
      if (!is_valid) {
        return [];
      }
      const assign_result = this.tabs.reduce((prev, curr) => {
        return prev.concat(curr.componentProps.tableData.map(({ advertiser_id, channel_alias, target }) => ({
          advertiser_id,
          channel_alias,
          options: target.options,
          value: target.value,
        })));
      }, []);
      return assign_result;
    },
  },
};
</script>

<style lang="scss" scoped>
.byte-dance-games-list {
  height: 500px;
}
</style>
